
// import AppDataSetting from '@/data/app-data-setting.js'

const findTodoItemProject = (vm, item) => {
  if (item.Event.ItemType === 'project') return vm.$store.getters.projects.find(o => o.ID === item.Event.ItemID)
  if (item.Event.ItemType === 'taskWorkingItem') {
    let taskWorkingItem = vm.$store.getters.taskWorkingItems.find(o => o.ID === item.Event.ItemID) 
    if (!taskWorkingItem) return null
    let task = attachTaskWorkingItemTask(vm, taskWorkingItem)
    if (!task) return null
    return vm.$store.getters.projects.find(o => o.ID === task.ProjectID)
  }
  if (item.Event.ItemType === 'workOrder') {
    // 找到工單的 task_working_item_id
    let workOrder = vm.$store.getters.workOrders.find(o => o.ID === item.Event.ItemID) 
    if (!workOrder) return null

    let taskWorkingItem = vm.$store.getters.taskWorkingItems.find(o => o.ID === workOrder.TaskWorkingItemID) 
    if (!taskWorkingItem) return null
    let task = attachTaskWorkingItemTask(vm, taskWorkingItem)
    if (!task) return null
    return vm.$store.getters.projects.find(o => o.ID === task.ProjectID)
  }
  if (item.Event.ItemType === 'projectDepartmentBudget') {
    // 找到專案部門預算的專案
    let projectDepartmentBudget = vm.$store.getters.projectDepartmentBudgets.find(o => o.ID === item.Event.ItemID) 
    if (!projectDepartmentBudget) return null
    return vm.$store.getters.projects.find(o => o.ID === projectDepartmentBudget.ProjectID)
  }
  if (item.Event.ItemType === 'compensatoryTime') {
    return '-'
  }
  if (item.Event.ItemType === 'leaveForm') {
    return '-'
  }

  window.console.warn(`AppDataSetting::findTodoItemProject, unknown item type:`, item.Event.ItemType)
  return null
}

// 根據使用者，找到使用者部門資料
const findUserDepartmentID = (vm, user) => {
  return (vm.$store.getters.userDepartments.find(o => o.UserID == user.ID)|| {}).DepartmentID
}
const findUserDepartment = (vm, user) => {
  let departmentID = findUserDepartmentID(vm, user);
  return vm.$store.getters.departments.find(o => o.ID == departmentID) || {};
}
const findUserDepartmentIDByID = (vm, userID) => {
  return (vm.$store.getters.userDepartments.find(o => o.UserID == userID)|| {}).DepartmentID
}

const findUserLevel = (vm, user) => (vm.$store.getters.userPositions.find(o => o.UserID == user.ID) || {}).Level;

const findUserLevelByUserID = (vm, userID) => (vm.$store.getters.userPositions.find(o => o.UserID == userID) || {}).Level;

// attack
const attachTaskWorkingItemTask = (vm, o) => {
  if(!o.Task || !o.Task.ID) {
    o.Task = vm.$store.getters.tasksMap[o.TaskID] || {}
  }
  return o.Task
}
// getTaskWorkingItemTask 不要把 task 搬移過去，造成記憶體消耗
const getTaskWorkingItemTask = (vm, o) => {
  return vm.$store.getters.tasksMap[o.TaskID] || {}
}

const AppDataSetting = {
  findTodoItemProject,
  findUserDepartmentIDByID,
  findUserDepartmentID,
  findUserDepartment,
  findUserLevel,
  findUserLevelByUserID,
  attachTaskWorkingItemTask,
  getTaskWorkingItemTask
}
export default AppDataSetting;